module.exports = __webpack_public_path__ + "static/media/patio.a5259ad1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/amenities/patio.svg
// module id = 572
// module chunks = 0